export const NAV_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "Contact", href: "/contact" },
];

export const STATS = [
  { value: 320, suffix: "+", label: "Premium screens deployed" },
  { value: 48, suffix: "M", label: "Monthly daily reach" },
  { value: 17, suffix: "", label: "Industries served" },
  { value: 99, suffix: "%", label: "Client retention" },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "The industry rents attention.",
    body: "Every agency in India buys the same media from the same networks. The margins are thin, the reach is generic, and the story is never truly yours.",
  },
  {
    n: "02",
    title: "We own the network.",
    body: "XMLOOPS operates a proprietary television channel, an in-house creative studio, and a curated digital estate — placed inside the rooms where India's decision-makers already spend their time.",
  },
  {
    n: "03",
    title: "Amplification, not advertising.",
    body: "We don't add another line item to your marketing plan. We give brands a compounding platform: owned airtime, owned screens, owned narratives — engineered as one system.",
  },
];

export const SERVICE_GROUPS = [
  {
    key: "owned-media",
    tag: "01 · Owned Media",
    title: "The XMLOOPS Network",
    desc: "A proprietary television channel and premium screen estate across airports, luxury hotels, fine dining, cinemas and executive workspaces.",
    items: ["XMLOOPS TV Channel", "Airport & Hotel Screens", "Cinema Pre-Roll", "Luxury Mall LEDs", "Fine-Dining Placements"],
  },
  {
    key: "digital",
    tag: "02 · Digital",
    title: "Performance & Growth",
    desc: "Full-funnel digital marketing engineered for measurable amplification, not vanity metrics.",
    items: ["Paid Media (Meta, Google, DV360)", "SEO & Content Ops", "Marketing Automation", "CRM & Lifecycle", "Analytics & Attribution"],
  },
  {
    key: "advertising",
    tag: "03 · Advertising",
    title: "Integrated Advertising",
    desc: "Cross-channel campaigns that ride owned-media as the base layer and scale via paid, PR and influence.",
    items: ["Brand Campaigns", "OTT & Connected TV", "OOH & Programmatic OOH", "PR & Earned Media", "Influencer Networks"],
  },
  {
    key: "creative",
    tag: "04 · Creative",
    title: "Story, Art & Craft",
    desc: "An in-house studio of writers, directors, designers and technologists shaping brand narratives.",
    items: ["Creative Direction", "Film & Motion", "Graphic & Print", "Photography", "Copy & Concept"],
  },
  {
    key: "branding",
    tag: "05 · Branding",
    title: "Identity Systems",
    desc: "From category positioning to living design systems — we build brands that behave like infrastructure.",
    items: ["Brand Strategy", "Naming & Positioning", "Visual Identity", "Design Systems", "Brand Guidelines"],
  },
  {
    key: "production",
    tag: "06 · Production",
    title: "Studio Production",
    desc: "TVCs, digital films, product films, and live shoots produced end-to-end at broadcast quality.",
    items: ["TVC Production", "Digital Films", "Product & Fashion", "Live Events", "Post & VFX"],
  },
  {
    key: "technology",
    tag: "07 · Technology",
    title: "Marketing Technology",
    desc: "Web, apps and data pipelines that connect the brand experience end to end.",
    items: ["Websites & Landing", "Mobile Apps", "MarTech Stack", "Data & Dashboards", "AI Enablement"],
  },
];

export const INDUSTRIES = [
  "Hospitality", "Real Estate", "Luxury Retail", "Automotive",
  "Healthcare", "BFSI", "F&B", "Fashion", "Entertainment",
  "Education", "D2C", "Tech & SaaS", "Travel", "Wellness",
  "Aviation", "Manufacturing", "Government",
];

export const CASE_STUDIES = [
  {
    tag: "Hospitality",
    title: "The launch of a five-star reimagined",
    metric: "3.4× booking lift in 90 days",
    img: "https://images.unsplash.com/photo-1515703944563-dbcfbf121b3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBkYXJrfGVufDB8fHx8MTc4NTMzMTQ5N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "Automotive",
    title: "Category launch of an EV challenger",
    metric: "112M owned-media impressions",
    img: "https://images.unsplash.com/photo-1545164415-0fae860defbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBsZWQlMjBzY3JlZW4lMjB3YWxsJTIwc3R1ZGlvfGVufDB8fHx8MTc4NTMzMTQ4N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "Luxury Retail",
    title: "A heritage house, re-introduced to India",
    metric: "27% footfall increase, Q-on-Q",
    img: "https://images.unsplash.com/photo-1604355714851-c1d5990e1696?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsZWQlMjBzY3JlZW4lMjB3YWxsJTIwc3R1ZGlvfGVufDB8fHx8MTc4NTMzMTQ4N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "BFSI",
    title: "A private bank's national repositioning",
    metric: "+41 NPS across HNI segment",
    img: "https://images.unsplash.com/photo-1762417419967-d5ccd2ebe463?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBuZW9uJTIwY2l0eSUyMG5pZ2h0JTIwbWVkaWF8ZW58MHx8fHwxNzg1MzMxNDg3fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const TESTIMONIALS = [
  {
    quote: "XMLOOPS is the only partner in India that hands you the media and the message. We stopped renting attention the day we signed.",
    name: "Aditi Rao",
    role: "CMO, Meridian Hotels",
  },
  {
    quote: "It felt less like hiring an agency and more like plugging into a network. The scale is quiet, cinematic and completely on-brand.",
    name: "Rohan Malhotra",
    role: "Founder, Volta Motors",
  },
  {
    quote: "Every quarter our owned-media footprint compounds. That's not a campaign — that's infrastructure.",
    name: "Karan Shah",
    role: "Head of Brand, Aureus Bank",
  },
];

export const FAQS = [
  {
    q: "What exactly is 'owned media' at XMLOOPS?",
    a: "We operate a proprietary television channel and a curated screen estate placed across airports, luxury hotels, cinemas, fine-dining venues, malls and premium workspaces. When you work with us, part of your campaign runs on media we own — the rest scales across paid, digital and earned.",
  },
  {
    q: "How are you different from a traditional agency?",
    a: "Traditional agencies rent media from networks and mark it up. We own the network. That means better placements, better pricing, tighter storytelling, and campaigns that compound over time instead of ending the day the budget stops.",
  },
  {
    q: "Do you work with early-stage brands or only enterprises?",
    a: "We work with category-defining brands at every stage — from ambitious D2C launches to publicly listed enterprises. Our packages are structured to scale with you.",
  },
  {
    q: "Which industries do you specialise in?",
    a: "Hospitality, luxury retail, real estate, automotive, BFSI, healthcare, F&B, education, aviation and premium D2C — categories where trust, prestige and consistent visibility drive commercial outcomes.",
  },
  {
    q: "How quickly can a campaign go live?",
    a: "Owned-media placements can be activated in as little as 10 working days. Full-funnel campaigns with creative production typically launch within 3–5 weeks.",
  },
  {
    q: "Do you disclose reach and performance data?",
    a: "Every engagement includes a live dashboard covering owned-media impressions, digital performance and attribution. Transparency is a product feature at XMLOOPS.",
  },
];

export const AWARDS = [
  "ABBY Awards 2024",
  "Kyoorius Creative",
  "Effies India",
  "Campaign South Asia",
  "Ad Club of India",
  "Big Bang Awards",
];

export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1762417419967-d5ccd2ebe463?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBuZW9uJTIwY2l0eSUyMG5pZ2h0JTIwbWVkaWF8ZW58MHx8fHwxNzg1MzMxNDg3fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1545164415-0fae860defbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBsZWQlMjBzY3JlZW4lMjB3YWxsJTIwc3R1ZGlvfGVufDB8fHx8MTc4NTMzMTQ4N3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1604355714851-c1d5990e1696?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsZWQlMjBzY3JlZW4lMjB3YWxsJTIwc3R1ZGlvfGVufDB8fHx8MTc4NTMzMTQ4N3ww&ixlib=rb-4.1.0&q=85",
];
